/*
 * Tab switcher for the PDP feature groups (2026-09 mockup). The section used to
 * render one <details> per group; the panels are now siblings of a tablist and
 * this element owns which one is shown. Liquid marks the first tab selected, so
 * there is no flash before this upgrades, and with JS off every panel but the
 * first stays hidden — still readable, just not switchable.
 */
if (!customElements.get('features-tabs')) {
  customElements.define(
    'features-tabs',
    class FeaturesTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        if (!this.tabs.length) return;

        this.onClick = this.onClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKeydown);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKeydown);
      }

      onClick(event) {
        const tab = event.target.closest('[role="tab"]');
        if (!tab || !this.tabs.includes(tab)) return;
        this.select(this.tabs.indexOf(tab));
      }

      onKeydown(event) {
        const tab = event.target.closest('[role="tab"]');
        if (!tab) return;

        const step = { ArrowRight: 1, ArrowLeft: -1, Home: -Infinity, End: Infinity }[event.key];
        if (step === undefined) return;

        event.preventDefault();
        const current = this.tabs.indexOf(tab);
        const last = this.tabs.length - 1;
        let next = current + step;
        if (step === -Infinity) next = 0;
        if (step === Infinity) next = last;
        if (next < 0) next = last;
        if (next > last) next = 0;

        this.select(next);
        this.tabs[next].focus();
      }

      select(index) {
        this.tabs.forEach((tab, i) => {
          const on = i === index;
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.tabIndex = on ? 0 : -1;
        });
        this.panels.forEach((panel, i) => (panel.hidden = i !== index));
      }
    }
  );
}
